// import * as React from "react";
// import { Box, Typography, useTheme, alpha, Stack } from "@mui/material";
// import { Button, Link, Title, usePermissions } from "react-admin";
// import CombinedInKindReport from "../../components/reports/thabat/CombinedInKindReport";
// import { Add as AddIcon } from '@mui/icons-material';

// const Offers = () => {
//   const theme = useTheme();
//   const { permissions } = usePermissions();

//   // Check if user can see create button
//   const canSeeActionButtons = permissions === 'admin' || permissions === 'operater';

//   return (
//     <Box
//       sx={{
//         background: `linear-gradient(135deg, ${alpha(
//           theme.palette.background.default,
//           0.9
//         )} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`,
//         p: 3,
//         borderRadius: "16px",
//       }}
//     >
//       <Title title="Offers Dashboard" />
      
//       {/* Header with title on left and button on right */}
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
//         <Box>
//           <Typography
//             variant="h4"
//             fontWeight="800"
//             sx={{
//               background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//               display: "inline-block",
//             }}
//           >
//             Offers (Donations)
//           </Typography>
//           <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
//             Manage all crop and service donations (type = donate)
//           </Typography>
//         </Box>

//         {canSeeActionButtons && (
//           <Stack direction="row" spacing={2}>
//             <Button
//               component={Link}
//               to="/in-kind-offers/create"
//               variant="contained"
//               color="primary"
//               startIcon={<AddIcon />}
//               sx={{
//                 background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//                 '&:hover': {
//                   background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
//                 }
//               }}
//             >
//               Create In-Kind Offer
//             </Button>
//           </Stack>
//         )}
//       </Box>

//       <CombinedInKindReport itemType="donate" />
//     </Box>
//   );
// };

// export default Offers;
// Offers.js
import * as React from "react";
import { useState } from "react";
import { Box, Typography, useTheme, alpha, Stack } from "@mui/material";
import { Button, Title, usePermissions } from "react-admin";
import CombinedInKindReport from "../../components/reports/thabat/CombinedInKindReport";
import InKindCreationModal from "../../components/reports/thabat/InKindCreationModal";
import { Add as AddIcon } from '@mui/icons-material';

const Offers = () => {
  const theme = useTheme();
  const { permissions } = usePermissions();
  const [modalOpen, setModalOpen] = useState(false);

  // Check if user can see create button
  const canSeeActionButtons = permissions === 'admin' || permissions === 'operater';

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.background.default,
          0.9
        )} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`,
        p: 3,
        borderRadius: "16px",
      }}
    >
      <Title title="Offers Dashboard" />
      
      {/* Header with title on left and button on right */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
        <Box>
          <Typography
            variant="h4"
            fontWeight="800"
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
            Offers (Donations)
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            Manage all crop and service donations (type = donate)
          </Typography>
        </Box>

        {canSeeActionButtons && (
          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => setModalOpen(true)}
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              sx={{
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                '&:hover': {
                  background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                }
              }}
            >
              Create In-Kind Donation
            </Button>
          </Stack>
        )}
      </Box>

      <CombinedInKindReport itemType="donate" />
      
      <InKindCreationModal 
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        itemType="donate"
      />
    </Box>
  );
};

export default Offers;